import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { FiscalYear, FiscalYearCreate, FiscalYearFilter } from '../data/fiscalYear';

export function createFiscalYearService(client: AxiosInstance) {
  return createCrudService<FiscalYear, FiscalYearCreate, FiscalYearFilter>(
    client,
    '/accounting/FiscalYear',
    'id',
  );
}

export type FiscalYearService = CrudService<FiscalYear, FiscalYearCreate, FiscalYearFilter>;
